/* These should be able to just be auto imported since they exist in the .nuxt/types/imports.d.ts,
 * but maybe one day eslint with get with it
 */
import { computed, } from 'vue';
import { defineNuxtPlugin, } from 'nuxt/app';

/**
 * Vue automatically wraps any returned reactive object or computed value in a proxy object to ensure reactivity, hence
 * why all these objects will be returned as proxy objects, and to access to raw value you must add *.value
 *
 * @returns {{
 * lastRefreshedAt: Readonly<Ref<SessionLastRefreshedAt>>,
 * data: Readonly<WrappedSessionData<SessionData>>,
 * signIn: typeof signIn,
 * loggedIn: ComputedRef<boolean>,
 * signOut: typeof signOut,
 * refresh: () => Promise<unknown>,
 * signUp: typeof signUp,
 * getSession: typeof getSession,
 * user: ComputedRef<unknown>,
 * token: Readonly<Ref<string | null>>,
 * refreshToken: Readonly<Ref<string | null>>,
 * status: ComputedRef<SessionStatus>
 *   }}
 */
export const useAuthExtended = () => {
  const auth = useAuth();

  /**
   * if accessing auth directly, you'll need to include .value since it's not a computed return.
   *
   * For loggedIn and user, you can access directly since they're returning computed .value
   *
   * but for anything USER related in the DOM, access it this way since the auth.user.* doesn't get unwrapped
   * by a vue because vue 3 doesn't unwrap deeply 💔
   * @example
   * // In setup():
   * const { user } = useNuxtApp().$auth;
   *
   * // in DOM
   * {{ user.first_name }}
   */

  return {
    ...auth,
    loggedIn: computed(() => auth.status.value === 'authenticated'),
    user: computed(() => auth.data?.value || null),
  };
};

export default defineNuxtPlugin((nuxtApp) => {
  const extendedAuth = useAuthExtended();
  nuxtApp.provide('auth', extendedAuth);
});
